/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__organization__model__SortByColumnEnum;

(function (jove__app__organization__model__SortByColumnEnum) {
  jove__app__organization__model__SortByColumnEnum["NAME"] = "name";
  jove__app__organization__model__SortByColumnEnum["SLUG"] = "slug";
  jove__app__organization__model__SortByColumnEnum["CREATED_AT"] = "created_at";
})(jove__app__organization__model__SortByColumnEnum || (jove__app__organization__model__SortByColumnEnum = {}));